import Request from './request';

export default class ValidationHttpService {
    private static uri = 'validations';

    public static validateCep(cep: string) {
        return Request.get(`${this.uri}/cep/${cep}`);
    }
}
